<!-- <div class="pwd_ctn">
  <div>
    <input
      nz-input
      [(ngModel)]="pwd.number0"
      type="password"
      maxlength="1"
      (ngModelChange)="change($event, 0)"
      class="number0"
      [readonly]="readonly[0]"
    />
  </div>
  <div>
    <input
      nz-input
      [(ngModel)]="pwd.number1"
      type="password"
      maxlength="1"
      (ngModelChange)="change($event, 1)"
      class="number1"
      [readonly]="readonly[1]"
    />
  </div>
  <div>
    <input
      nz-input
      [(ngModel)]="pwd.number2"
      type="password"
      maxlength="1"
      (ngModelChange)="change($event, 2)"
      class="number2"
      [readonly]="readonly[2]"
    />
  </div>
  <div>
    <input
      nz-input
      [(ngModel)]="pwd.number3"
      type="password"
      maxlength="1"
      (ngModelInput)="change($event, 3)"
      class="number3"
      [readonly]="readonly[3]"
    />
  </div>
  <div>
    <input
      nz-input
      [(ngModel)]="pwd.number4"
      type="password"
      maxlength="1"
      (ngModelChange)="change($event, 4)"
      class="number4"
      [readonly]="readonly[4]"
    />
  </div>
  <div>
    <input nz-input [(ngModel)]="pwd.number5" type="password" maxlength="1" (ngModelChange)="change($event, 5)" class="number5" />
  </div>
</div> -->

<div class="pwd">
  <input type="text" [(ngModel)]="password" (ngModelChange)="change($event)" (blur)="blur()" class="paypwdInput" maxlength="6" />
  <div (click)="foucsFun()" class="ul_ctn">
    <div>
      <!-- <input nz-input type="password" maxlength="1" [(ngModel)]="passwordArr[0]" readonly /> -->
      <span *ngIf="password.length > 0"></span>
      <i *ngIf="focusStatus && password.length == 0"></i>
    </div>
    <div>
      <!-- <input nz-input type="password" maxlength="1" [(ngModel)]="passwordArr[1]" readonly /> -->
      <span *ngIf="password.length > 1"></span>
      <i *ngIf="focusStatus && password.length == 1"></i>
    </div>
    <div>
      <!-- <input nz-input type="password" maxlength="1" [(ngModel)]="passwordArr[2]" readonly /> -->
      <span *ngIf="password.length > 2"></span>
      <i *ngIf="focusStatus && password.length == 2"></i>
    </div>
    <div>
      <!-- <input nz-input type="password" maxlength="1" [(ngModel)]="passwordArr[3]" readonly /> -->
      <span *ngIf="password.length > 3"></span>
      <i *ngIf="focusStatus && password.length == 3"></i>
    </div>
    <div>
      <!-- <input nz-input type="password" maxlength="1" [(ngModel)]="passwordArr[4]" readonly /> -->
      <span *ngIf="password.length > 4"></span>
      <i *ngIf="focusStatus && password.length == 4"></i>
    </div>
    <div>
      <!-- <input nz-input type="password" maxlength="1" [(ngModel)]="passwordArr[5]" readonly /> -->
      <span *ngIf="password.length > 5"></span>
      <i *ngIf="focusStatus && password.length >= 5"></i>
    </div>
  </div>
</div>
